import { useState, useEffect, useMemo } from "react";
import axios from "axios";

const useAmendments = (
  fileId?: string,
  textId?: string,
  page?: number,
  userId?: string,
  filters?: {
    id: number;
    metric: {
      label: string;
      value: string;
    }[];
    symbol: {
      label: string;
      value: string;
    }[];
    value: {
      label: string;
      value: string;
    }[];
  }[],
  deputyId?: string,
  signalId?: string,
  amendmentsTextFollowed?: boolean,
  amendmentsTextNotFollowed?: boolean,
  exportMode?: boolean,
  keywordsFilterBar?: string[]
) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const memoizedFilters = useMemo(() => JSON.stringify(filters), [filters]);
  const memoizedKeywords = useMemo(
    () => JSON.stringify(keywordsFilterBar),
    [keywordsFilterBar]
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const params: any = {
          page: page,
        };

        if (exportMode) {
          params.export = true;
        }

        if (fileId && textId) {
          console.log("File:", fileId);
          params.uid = fileId;
          params.textId = textId;
          params.userId = userId;
        } else if (deputyId) {
          console.log("Deputy:", deputyId);
          params.deputyId = deputyId;
          params.userId = userId;
        } else if (signalId) {
          console.log("Signal hook:", signalId);
          params.signalId = signalId;
          params.userId = userId;
        } else if (amendmentsTextFollowed) {
          console.log("Amendments text followed:", amendmentsTextFollowed);
          params.amendmentsTextFollowed = amendmentsTextFollowed;
          params.userId = userId;
        } else if (amendmentsTextNotFollowed) {
          console.log(
            "Amendments text not followed filter:",
            amendmentsTextNotFollowed
          );
          params.amendmentsTextNotFollowed = amendmentsTextNotFollowed;
          params.userId = userId;
        }

        if (filters && filters.some((filter) => filter || filter || filter)) {
          params.filters = JSON.stringify(filters);
        }

        if (keywordsFilterBar && keywordsFilterBar.length > 0) {
          params.keywordsFilterBar = JSON.stringify(keywordsFilterBar);
        }

        const response = await axios.get(
          `https://oparl-textprovider-production.up.railway.app/amendments`,
          //`http://localhost:1080/amendments`,

          { params }
        );
        setData(response.data);
        setError(null);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          setError(`Error: ${err.response.statusText}`);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred");
        }
      } finally {
        setLoading(false);
      }
    };

    if (
      (fileId && textId) ||
      deputyId ||
      signalId ||
      amendmentsTextFollowed ||
      amendmentsTextNotFollowed
    ) {
      fetchData();
    } else {
      setData([]);
      setLoading(false);
    }
  }, [
    fileId,
    textId,
    memoizedFilters,
    page,
    deputyId,
    filters,
    userId,
    signalId,
    amendmentsTextFollowed,
    amendmentsTextNotFollowed,
    exportMode,
    keywordsFilterBar,
    memoizedKeywords,
  ]);

  return { data, loading, error };
};

export default useAmendments;
